import { Stripe, StripeElementLocale } from '@stripe/stripe-js'
import { LocaleEnum, PaymentMethodEnum } from '@systemeio/ui'
import { UseUserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface'
import { LanguageCodeEnum, getLanguageCodeByLocale } from 'shared/enums/language-code-enum'

type SupportedStripeLocale = Exclude<
  LanguageCodeEnum,
  | LanguageCodeEnum.SERBIAN
  | LanguageCodeEnum.UKRAINIAN
  | LanguageCodeEnum.ALBANIA
  | LanguageCodeEnum.HINDI
>

const UNSUPPORTED_STRIPE_LOCALES = [
  LanguageCodeEnum.SERBIAN,
  LanguageCodeEnum.UKRAINIAN,
  LanguageCodeEnum.ALBANIA,
  LanguageCodeEnum.HINDI,
]
const isSupported = (lang: LanguageCodeEnum): lang is SupportedStripeLocale =>
  !UNSUPPORTED_STRIPE_LOCALES.includes(lang)

export const getStripeSupportedLocale = (locale: LocaleEnum): StripeElementLocale => {
  const languageCode = getLanguageCodeByLocale(locale)

  if (!isSupported(languageCode)) {
    return 'auto'
  }

  return languageCode
}

export const getStripeCustomerConfirmIntentMethod = (
  stripe: Stripe | null,
  paymentMethod?: UseUserPlanInterface['customer']['paymentMethod'],
) => {
  if (stripe && paymentMethod) {
    switch (paymentMethod) {
      case PaymentMethodEnum.stripe_card:
      case PaymentMethodEnum.stripe_applepay:
        return stripe.confirmCardPayment
      case PaymentMethodEnum.stripe_ideal:
        return stripe.confirmIdealPayment
      case PaymentMethodEnum.stripe_bancontact:
        return stripe.confirmBancontactPayment
      default:
        break
    }
  }
}
